// extracted by mini-css-extract-plugin
export default {"meal":"MealItem_meal__izQ8U","description":"MealItem_description__a4Qwd","price":"MealItem_price__ISzqh"};